import debounce from 'lodash/debounce'
import { useEffect, useMemo } from 'preact/hooks'

const useDebounce = (onChange: (field: string, value: string) => void) => {
  const debouncedChangeHandler = useMemo(() => debounce((field, val) => onChange(field, val), 100), [])

  useEffect(() => () => debouncedChangeHandler.cancel(), [debouncedChangeHandler])

  return debouncedChangeHandler
}

export default useDebounce
